import { useDispatch, useSelector } from "react-redux";
import { setLoadingAction, clearLoadingAction } from "../redux/loading";

const useLoading = () => {

  const dispatch = useDispatch();
  const loading = useSelector( state => state.loading );
  const setLoading = (payload) => {
    dispatch(setLoadingAction(
      payload ? payload : { isShowSpinner: true, spinnerType: '1' }
    ))
  };
  const clearLoading = () => { dispatch( clearLoadingAction() ) };

  return {
    loading,
    setLoading,
    clearLoading
  };

};

export default useLoading;
